<span [class]="'icon icon-' + icon" *ngIf="icon"></span>
<ng-content></ng-content>
